import React from 'react'
import { Container, Body, Arrow, Icon, Item } from './styles'

interface HeadingProps {
    onClick: (element: string) => void
}
const Heading = ({ onClick }: HeadingProps): JSX.Element => {
    return (
        <Container>
            <Arrow />
            <Body>
                <Item onClick={() => onClick('H1')}>
                    <Icon className={'fas fa-h1'} />
                </Item>
                <Item onClick={() => onClick('H2')}>
                    <Icon className={'fas fa-h2'} />
                </Item>
                <Item onClick={() => onClick('H3')}>
                    <Icon className={'fas fa-h3'} />
                </Item>
                <Item onClick={() => onClick('H4')}>
                    <Icon className={'fas fa-h4'} />
                </Item>
            </Body>
        </Container>
    )
}

export default Heading
